export const REQUEST_TOO_LARGE_ERROR = 'RequestTooLargeError';
export const requestTooLargeError = (message) => {
  const error = new Error(message);
  error.name = REQUEST_TOO_LARGE_ERROR;
  return error;
}